export var SELECTION_TYPES = {
    all: 'all',
    allExcept: 'allExcept',
    individual: 'individual',
};
